module.exports = __webpack_public_path__ + "static/img/hover-iocn67.bf5b402.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/add_icon/hover-iocn67.png
// module id = f/L2
// module chunks = 1